import React, { type ReactElement, type ReactNode } from 'react'

import { useIntl } from 'react-intl'

import { Typography, customTV, useTheme } from '@themenu/design-system'

export const typographyLinkStyle = customTV({
  base: [
    'ml-xxs inline-block align-middle',
    "before:content-[''] [&:not(:first-child)]:before:border-r before:mr-xxs before:opacity-50",
  ],
})

type LegalLinkFooterProps = {
  /** Extra item rendered before the legal links, in the same row. */
  leading?: ReactNode
  /** Skip the legal links entirely and render only `leading`. */
  hideLinks?: boolean
}

export const LegalLinkFooter = ({ leading, hideLinks = false }: LegalLinkFooterProps = {}): ReactElement => {
  const theme = useTheme()
  const { formatMessage } = useIntl()

  const linkTypeToIntlId = {
    legalNotices: 'sign_in_page.legal_links.legal_notice',
    privacy: 'sign_in_page.legal_links.privacy_policy',
    cgu: 'sign_in_page.legal_links.cgu',
    cookies: 'sign_in_page.legal_links.cookies',
  }

  return (
    <div className={hideLinks ? 'text-right' : 'text-center'}>
      {leading}
      {!hideLinks &&
        Object.entries(linkTypeToIntlId).map(([linkName, linkIntlId]) => {
          const linkUrlId = `${linkIntlId}.link`
          const linkUrl = formatMessage({ id: linkUrlId })
          const linkPresent = linkUrl !== linkIntlId
          const title = formatMessage({ id: `${linkIntlId}.title` })

          return (
            linkPresent && (
              <Typography
                key={linkName}
                variant="callout"
                component="a"
                href={linkUrl}
                target="_blank"
                style={{ color: theme.colors.content.placeholder }}
                className={typographyLinkStyle()}
              >
                {title}
              </Typography>
            )
          )
        })}
    </div>
  )
}
